<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="block text-xs text-gray-700 uppercase tracking-wider">order item</span>
      <h3 class="text-2xl text-gray-900">Τροποποίηση</h3>
    </template>

    <template #default="modalProps">
      <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
        <form @submit.prevent="handleSubmit(doUpdate)">
          <BaseLayoutSpaced relaxed>
            <BaseLayoutSpaced>
              <ValidationProvider
                v-for="field in formFieldsWithDefaults"
                :key="field.name"
                :name="field.prettyName"
                :vid="field.name"
                :rules="field.validation"
                v-slot="{ errors, failed }"
                slim
              >
                <BaseFormGroup>
                  <BaseFormLabel :for="`${_uid}-${field.name}`">
                    {{ field.label }} <template v-if="field.validation.required"> * </template>
                  </BaseFormLabel>
                  <Component
                    v-model="data[field.name]"
                    :is="field.component"
                    :disabled="submitting"
                    v-bind="{
                      ...field.options.props,
                      ...field.options.attrs,
                    }"
                    :invalid="failed"
                    :id="`${_uid}-${field.name}`"
                  />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </ValidationProvider>
            </BaseLayoutSpaced>
            <div class="flex space-x-2 py-1 items-baseline">
              <BaseButton primary type="submit" :disabled="invalid || submitting">
                <span v-if="!submitting">Update</span>
                <Loader v-else small inverse />
              </BaseButton>
              <BaseButton ghost type="button" @click="modalProps.close" :disabled="submitting">
                Close
              </BaseButton>
              <BaseFormInlineMessage v-if="message" danger>
                {{ message }}
              </BaseFormInlineMessage>
            </div>
          </BaseLayoutSpaced>
        </form>
      </ValidationObserver>
    </template>
  </BaseModal>
</template>

<script>
const defaultField = {
  component: null,
  label: '',
  name: '',
  options: {},
  validation: {},
};

const defaultData = {
  name: null,
  status: null,
  pricePerUnit: null,
  requirements: null,
};

export default {
  props: {
    orderItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    submitting: false,
    data: null,
    message: null,
  }),
  computed: {
    formFields() {
      return [
        {
          component: 'BaseFormInput',
          label: 'Name',
          name: 'name',
          prettyName: 'name',
          options: {
            attrs: {
              name: 'name',
              class: 'w-full',
            },
          },
          validation: {
            required: true,
          },
        },
        {
          component: 'BaseFormSelect',
          label: 'Status',
          name: 'status',
          prettyName: 'status',
          options: {
            attrs: {
              name: 'status',
              class: 'w-full',
            },
            props: {
              options: [
                { label: 'Draft', value: 'draft' },
                { label: 'Pending', value: 'pending' },
                { label: 'In Progress', value: 'in progress' },
                { label: 'In Review', value: 'in review' },
                { label: 'Completed', value: 'completed' },
              ],
            },
          },
          validation: {
            required: false,
          },
        },
        {
          component: 'BaseFormInput',
          label: 'Price',
          name: 'pricePerUnit',
          prettyName: 'price',
          options: {
            attrs: {
              name: 'pricePerUnit',
              type: 'number',
              step: '0.01',
              min: 0,
            },
          },
          validation: {
            required: true,
            min: 0,
          },
        },
      ];
    },
    formFieldsWithDefaults() {
      return this.formFields.map((x) => ({ ...defaultField, ...x }));
    },
  },
  created() {
    this.data = { ...defaultData, ...this.orderItem };
  },
  methods: {
    async doUpdate() {
      this.$emit('update', this.data);

      this.$refs.modal.doClose();
    },
  },
};
</script>
